import { render, staticRenderFns } from "./generateKey.vue?vue&type=template&id=31a884a1&scoped=true&"
import script from "./generateKey.vue?vue&type=script&lang=js&"
export * from "./generateKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a884a1",
  null
  
)

export default component.exports